<template>
  <div>
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
     
      min-width="290px"
    >
 
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="date"
         :picker-date="2019"
         :reactive="true"
         :scrollable="true"
         :value="date"
          prepend-icon="far fa-calendar-alt"
          readonly
          v-on="on"
        >
           <template slot="label">
      <span v-html="label" />
    </template>
        </v-text-field>
      </template>
      <v-date-picker
        ref="picker"
        v-model="date"
        :max="max"
        :min="min"
        @change="save"
        :locale= this.language
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import localStorageSvc from "@/services/localStorage";
// new Date().toISOString().substr(0, 10)
export default {
  props: ["min", "max", "value", "label"],
  data() {
    return {
      date: null,
      menu: false,
      language: "en"
    };
  },
  created(){
    var lan = localStorageSvc.getLanID();
    if(lan == 1){
      this.language = "en";
    }else{
      this.language = "fr";
    }
    this.data = this.value;
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (
        this.$refs.picker.activePicker = "YEAR"
      ));
    },
    value(n) {          
      this.date = n;
    }
  },
  methods: {
    save(date) {
      this.$emit("input", date);
      this.$refs.menu.save(date);
    }
  }
};
</script>

<style></style>
